import { http, getAccess } from './http';

const CURRENT_USER_KEY = 'current_user';
const CURRENT_USER_STAMP_KEY = 'current_user__stamp';
// TTL 5 минут — по ТЗ «Рабочие задачи» блок 1: при смене роли администратором
// UI не должен показывать старую роль дольше 5 минут без ре-логина.
const CURRENT_USER_TTL_MS = 5 * 60 * 1000;

export function getCachedCurrentUser() {
    try {
        const raw = localStorage.getItem(CURRENT_USER_KEY);
        if (!raw) return null;
        const stampRaw = localStorage.getItem(CURRENT_USER_STAMP_KEY);
        const stamp = stampRaw ? Number(stampRaw) : 0;
        if (!stamp || (Date.now() - stamp) > CURRENT_USER_TTL_MS) {
            // Кэш протух — не возвращаем, вынудим перезапрос
            return null;
        }
        return JSON.parse(raw);
    } catch {
        return null;
    }
}

export function setCachedCurrentUser(user) {
    try {
        if (!user) return;
        localStorage.setItem(CURRENT_USER_KEY, JSON.stringify(user));
        localStorage.setItem(CURRENT_USER_STAMP_KEY, String(Date.now()));
    } catch {
        // ignore
    }
}

export function clearCachedCurrentUser() {
    try {
        localStorage.removeItem(CURRENT_USER_KEY);
        localStorage.removeItem(CURRENT_USER_STAMP_KEY);
    } catch {
        // ignore
    }
}

// Получить список всех пользователей
export async function getUsers(params = {}) {
  try {
    const response = await http.get('/users/', { params })
    return response.data.data || response.data.results || response.data
  } catch (error) {
    console.error('Ошибка загрузки пользователей:', error)
    return []
  }
}

// Декодирование JWT токена для получения данных пользователя
function parseJWT(token) {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    } catch (e) {
        console.error('Failed to parse JWT:', e);
        return null;
    }
}

export async function getCurrentUser() {
    try {
        // 1) Preferred: users/me/
        try {
            const { data } = await http.get('users/me/');
            return data;
        } catch {
            // fallback below
        }

        // 2) Fallback: use user_id from JWT
        const token = getAccess();
        if (token) {
            const payload = parseJWT(token);
            if (payload && payload.user_id) {
                const { data } = await http.get(`users/${payload.user_id}/`);
                return data;
            }
        }
        return null;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to get current user:', error);
        return null;
    }
}

export async function ensureCurrentUser({ force = false } = {}) {
    if (!force) {
        const cached = getCachedCurrentUser();
        if (cached) return cached;
    }
    const user = await getCurrentUser();
    if (user) setCachedCurrentUser(user);
    return user;
}

export async function getUserRoles() {
    try {
        const user = await ensureCurrentUser();
        if (!user) return null;
        
        if (user.roles) return user.roles;
        if (user.role) return user.role;
        if (user.position) return user.position;
        if (user.position_name) return user.position_name;
        
        try {
            const { data } = await http.get(`users/${user.id}/roles/`);
            return data;
        } catch (e) {
            // endpoint may not exist
        }
        
        return null;
    } catch (error) {
        console.error('Failed to get user roles:', error);
        return null;
    }
}
